import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import WPErrorBoundary from "./common/utils/WPErrorBoundary";
import WPErrorFullPage from "./packages/WPErrorFullPage/WPErrorFullPage";

import AddNewPlant from "./pages/addNewPlant";
import AdminPage from "./pages/AdminPortal";
import LicenseManagementPage from "./pages/AdminPortal/licenseManagementPage";
import UserPage from "./pages/AdminPortal/userManage";
import AnalyseData from "./pages/analyseData";
import DocumentationPage from "./pages/documentation";
import Home from "./pages/appHome";
import RoAdvisorHome from "./pages/home";
import LifetimeAdvisorHome from "./pages/lifetimeAdvisorHome";
import MessagePage from "./pages/messageDisplayPage";
import PlantsPage from "./pages/plantsPage";
import RequestAccess from "./pages/requesAccessPage";
import { RootLayout } from "./RootLayout";

import { APP_ROUTES } from "./constants/global.constants";
import { API_RESPONSE_CODE } from "./constants/apiResponseCode.constants";

import { updatePlantId } from "./utils/Utils";

import { API_URLS } from "./network/appUrls";

const searchParams = new URLSearchParams(window.location.search);
const plantId = searchParams.get("plantId");
updatePlantId(plantId);

const basePath = API_URLS.basePath;

const routes = [
  {
    errorElement: <WPErrorFullPage errorCode={API_RESPONSE_CODE.APP_CRASH} />,
    element: (
      <WPErrorBoundary>
        <RootLayout />
      </WPErrorBoundary>
    ),
    children: [
      {
        path: APP_ROUTES.ROOT,
        element: <PlantsPage />,
      },
      {
        path: APP_ROUTES.PLANTS,
        element: <PlantsPage />,
      },
      // remove this route later(added for users who have bookmarked /plant page, to avoid breaking their bookmark)
      {
        path: APP_ROUTES.PLANT_LEGACY,
        element: <Navigate to={`/${APP_ROUTES.PLANTS}`} replace />,
      },
      {
        path: APP_ROUTES.ADD_PLANT,
        element: <AddNewPlant />,
      },
      {
        path: APP_ROUTES.EDIT_PLANT,
        element: <AddNewPlant />,
      },
      {
        path: APP_ROUTES.ANALYSE_DATA,
        element: <AnalyseData />,
      },
      {
        path: APP_ROUTES.HOME,
        element: <Home />,
      },
      {
        path: APP_ROUTES.CLEANING_ADVISOR_HOME,
        element: <RoAdvisorHome />,
      },
      {
        path: APP_ROUTES.LIFETIME_ADVISOR_HOME,
        element: <LifetimeAdvisorHome />,
      },
      {
        path: APP_ROUTES.UNAUTHORIZED,
        element: <WPErrorFullPage />,
      },
      {
        path: APP_ROUTES.MAINTENANCE,
        element: <WPErrorFullPage />,
      },
      {
        path: APP_ROUTES.REQUEST_ACCESS,
        element: <RequestAccess />,
      },
      {
        path: APP_ROUTES.MESSAGE_PAGE,
        element: <MessagePage />,
      },
      {
        path: APP_ROUTES.ADMIN_PORTAL,
        element: <AdminPage />,
      },
      {
        path: APP_ROUTES.USER_MANAGEMENT,
        element: <UserPage />,
      },
      {
        path: APP_ROUTES.LICENSE_MANAGEMENT,
        element: <LicenseManagementPage />,
      },
      {
        path: APP_ROUTES.DOCUMENTATION,
        element: <DocumentationPage />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  basename: basePath,
});
